import { lazy, ReactElement } from 'react';
import ProtectedRoute from '@/components/ProtectedRoute';

const MeuPerfil = lazy(() => import('./Index'));

type RouteEntry = { path: string; element: ReactElement; layout?: string };

export const meRoutes: RouteEntry[] = [
    {
        path: '/me',
        element: (
            <ProtectedRoute>
                <MeuPerfil />
            </ProtectedRoute>
        ),
    },
];
